import React from "react";
import styles from "./pageloader.module.scss";
import Lottie from "lottie-react";
import { AssetStore } from "../../assets/AssetsStore";

function PageLoader() {
  return (
    <div className={styles.container}>
      <Lottie
        className={styles.lottieContainer}
        animationData={AssetStore.pageloader}
        loop={true}
      />
    </div>
  );
}

export default PageLoader;
